import { Content } from '@carbon/react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import './App.scss';
import { Layout } from './Layout';
import Login from './Auth/login';
import PrivateRoute from './Routes/private';
import Home from './Components/Pages/Home';
import About from './Components/Pages/About';
import Search from './Components/Pages/Search';
import Inventory from './Components/Pages/Inventory';
import VehicleReport from './Components/Pages/Report/Vehicle';
import VenusReport from './Components/Pages/Report/Venus';
import WeaponsReport from './Components/Pages/Report/Weapons';
import ManageUsers from './Components/Pages/Admin/ManageUser';
import Resource from './Components/Pages/Admin/Resource';
import ManageUserDetails from './Components/Pages/User/ManageUser';
import UserResource from './Components/Pages/User/Resources.js';
import { useEffect } from 'react';
import { userAuth } from './Utils/common';

function App() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!userAuth() && pathname !== '/login') {
      navigate('/login');
    }
  }, [pathname, navigate]);

  return (
    <div className="App">
      {pathname === '/login' ? null : <Layout />}
      <Content
        className={pathname === '/login' ? 'cds--padding-0' : 'main-content'}
      >
        <Routes>
          <Route
            exact
            path="/report/vehicle-utilization"
            element={
              <PrivateRoute>
                <VehicleReport />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/report/venus-utilization"
            element={
              <PrivateRoute>
                <VenusReport />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/report/weapons-utilization"
            element={
              <PrivateRoute>
                <WeaponsReport />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/admin/manage-user"
            element={
              <PrivateRoute>
                <ManageUsers />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/admin/resources"
            element={
              <PrivateRoute>
                <Resource />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/user/user-details"
            element={
              <PrivateRoute>
                <ManageUserDetails />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/user/resources-list"
            element={
              <PrivateRoute>
                <UserResource />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/home"
            element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/search"
            element={
              <PrivateRoute>
                <Search />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/about"
            element={
              <PrivateRoute>
                <About />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/inventory"
            element={
              <PrivateRoute>
                <Inventory />
              </PrivateRoute>
            }
          />
          <Route exact path="/login" element={<Login />} />
          <Route path="/*" element={<Login />} />
        </Routes>
      </Content>
    </div>
  );
}

export default App;
